import retext from 'retext';
import pos from 'retext-pos';
import english from 'retext-english';
import Analyzer from './AnalyzerModule';
import { BuilderPreferences } from '../../entities/BuilderPreferences';
import KeyWordParser from '../KeyWordParser';

export enum TextAnalysisResult {
    improvement = "Improvement",
    goodResult = "Good Result"
}

export enum TextAnalysisCategory {
    transitional_words = "Transitional words",
    subheading_distribution = "Subheading distribution",
    scripture_saturation = "Scripture saturation",
    flesch_reading_ease = "Flesch reading ease",
    passive_voice = "Passive voice",
    paragraph_length = "Paragraph length",
    sentence_length = "Sentence length",
    consecutive_sentences = "Consecutive sentences"
}

export interface TextAnalysis {
    result?: TextAnalysisResult;
    title: TextAnalysisCategory;
    displayText: string;
    helperText: string;
    color?: string; 
}

export interface AnalyzerResult {
    wordCount: number;
    characterCount: number;
    gradeLevel: string;
    improvements: TextAnalysis[];
    goodResults: TextAnalysis[];
    keywords: string[];
    scriptureReferences: string[];
}

export const SermonAnalyzer = {
    analyze: (text:string, preferences:BuilderPreferences) => {
        let results:AnalyzerResult = {     
            wordCount: 0,
            characterCount: 0,
            gradeLevel: '',
            improvements: [],
            goodResults: [],
            keywords: [],
            scriptureReferences: [],
        };

        let subheadingCount:number = 0;

        let search = text.replace(/<(?:.|\n)*?>/gm, (match) => {
                if (match === '<h2>'){
                    subheadingCount++;
                }
                if (match === '</p>'){
                    return ' \n';
                }
                if(match[1] === '/'){
                    return ' '
                }

                return '';
            })
            .replace(/&nbsp/gm, ' ')

        let characterCount = text.replace(/<(?:.|\n)*?>/gm, '').replace(/&nbsp/gm, '').length;
        let keywords = KeyWordParser.parseKeywords(text, [], 10);

        retext()
        .use(english)
        .use(pos)
        .use(Analyzer, subheadingCount, preferences)
        .process(search, (err:Error, file:any) => {

            results = {
                wordCount: file.wordCount,
                characterCount: characterCount,
                keywords: keywords ? keywords.slice(0, 10) : [],
                gradeLevel: file.gradeLevel,
                goodResults: file.goodResults,
                improvements: file.improvements,
                scriptureReferences: file.scriptureReferences,
            }
        });

        return results;
    }
}

export default SermonAnalyzer